import { request } from '../util/request'
import { bdBuriedUrl } from '../util/config'
/**
 * @name NewPayTrade
 * @desc 微信配置接口、微信分享调用
 * @param {object} data "clientPayType":"web","orderSn":"INSHB2020050611191900000477","payType":"alipayAcc","token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.
 * @param {string} data.clientPayType
 * @param {string} data.orderSn
 * @param {string} data.payType - weichatAcc微信支付  alipayAcc支付宝支付
 * @param {string} data.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function NewPayTrade(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/tradeResource/newPayTrade`,
    method: 'post',
    data,
    loadingConfig
  })
}
// /**
//  * @desc 银联云闪付接口
//  * @param {objct} data 
//  * @param {object} loadingConfig 
//  */
// export function NewPayTradeUnionPay(data = {}, loadingConfig = {}) {
//   return request({
//     url: `${process.env.VUE_APP_API_PATH}/services/front/tradeResource/newPayTradeUnionPay `,
//     method: 'post',
//     data,
//     loadingConfig
//   })
// }
/**
 * @name GetClientIp
 * @desc 获取用户ip地址
 * */
export function GetClientIp() {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/tradeResource/getCreateIp`,
    method: 'GET'
  })
}

/**
 * @name bdPromotion
 * @desc 上报百度埋点渎职
 * */
 export function bdPromotion(data) {
  return request({
    url: `${bdBuriedUrl}/scrm-bus-process-center/bdPromotion/push`,
    method: 'POST',
    data
  })
}